import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import {
  Typography,
  Button,
  CircularProgress,
  Alert,
  styled,
  DialogTitle,
  IconButton,
  DialogContent,
  Dialog,
  Stack,
  DialogActions,
} from "@mui/material";
import {
  getMyNeop,
  getCnReimburse,
  getGenerateTransportasi,
  getSkTreatment,
  myJobs,
  setSnackbarOpen,
  updateAgreementTest,
  updateCandidateMCU,
  updateCandidateSign,
  uploadFileJp,
  uploadFileGeneral,
} from "src/redux/actions";
import localforage from "localforage";
import { domain } from "src/components/Layout/dummy";
import ModalSelectDateMCU from "../Modal/ModalSelectDateMCU";
import ModalSignContractRequired from "../Modal/ModalSignContractRequired";
import TableMaterial from "./TableMaterial";
import ModalUploadTreatment from "../Modal/ModalUploadTreatment";
import ModalUploadReimburse from "../Modal/ModalUploadReimburse";
import ModalNeop from "../Modal/ModalNeop";
import ModalConfirmTest from "../Modal/ModalConfirmTest";
import ModalAgreementTest from "../Modal/ModalAgreementTest";
import ModalConfirmOffering from "../Modal/ModalConfirmOffering";
import { Close } from "@material-ui/icons";
import { loadImage } from "src/functions/utils";

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    backgroundColor: "rgb(255,255,255)",
    borderRadius: "1rem",
    border: "1px solid lightgrey",
    // maxWidth: "350px",
  },
}));

function isEpochOlderThanOneYear(epochMicroseconds) {
  // Konversi mikrodetik ke milidetik
  const epochMillis = Math.floor(epochMicroseconds / 1000);

  // Waktu sekarang dalam milidetik
  const now = Date.now();

  // 1 tahun dalam milidetik (365 hari)
  const oneYearMillis = 365 * 24 * 60 * 60 * 1000;

  // Cek apakah sekarang - epoch >= 1 tahun
  return now - epochMillis >= oneYearMillis;
}

const MyCareer = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingModal, setLoadingModal] = useState(false);
  const [openModal, setOpenModal] = useState("");
  const [dataDetail, setDataDetail] = useState({});
  const [openReimburse, setOpenReimburse] = useState(false);
  const [detailReimburse, setDetailReimburse] = useState({});
  const [candidateNeop, setCandidateNeop] = useState([]);
  const [openModalAgreement, setOpenModalAgreement] = useState(false);
  const [loadingAgree, setLoadingAgree] = useState(false);
  const [loadingOffering, setLoadingOffering] = useState(false);
  const [loadingBerkas, setLoadingBerkas] = useState(false);
  const [openTreatment, setOpenTreatment] = useState(false);
  const [refTaxStatus, setRefTaxStatus] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [formB64, setFormB64] = useState("");
  const [font, setFont] = useState("");
  const [loadingDeklarasi, setLoadingDeklarasi] = useState(false);
  const [openDeklarasi, setOpenDeklarasi] = useState(false);
  const [draftB64, setDraftB64] = useState("");

  useEffect(() => {
    fetchData();
  }, [openReimburse]);

  const fetchData = async () => {
    setLoading(true);
    const resTheme = await localforage.getItem("theme");
    if (resTheme.websiteFor === "recruitment") {
      const resJobs = await myJobs({ domain });
      setData(resJobs.data);
    }
    setFont(resTheme.font);
    setLoading(false);
  };

  const handleStart = (d) => {
    setDataDetail(d);
    const psikotestStartAt = new Date(d?.psikotest?.started_at_ftd);
    const psikotestFinishAt = new Date(d?.psikotest?.finished_at_ftd);
    const dateNow = new Date();
    if (d?.candidate_logs[0]?.ref_pipeline?.pipeline_type === "call") {
      const cnLastLogs = d?.candidate_logs[0];
      if (cnLastLogs?.meeting_eligible) {
        window.open(cnLastLogs?.meeting_room?.meeting_url);
      } else {
        setSnackbarOpen(
          "error",
          "Anda sedang tidak berada pada waktu Interview",
        );
      }
      return;
    }

    if (dateNow.getTime() >= psikotestStartAt.getTime()) {
      if (dateNow.getTime() <= psikotestFinishAt.getTime()) {
        if (d.is_agree_test) {
          const participantId = d.psikotest?.user_data?.user_id;
          const pass = d.psikotest?.user_data?.password;
          const newWindow = window.open(
            // `https://entrance.shratech.com/entrance/pages/login?email=${participantId}&password=${pass}&ecommerceUrl=${window.location.hostname}`,
            `${window.location.origin}/entrance/pages/login?email=${participantId}&password=${pass}&ecommerceUrl=${window.location.hostname}`,
            "_self",
            "noopener,noreferrer",
          );
          if (newWindow) newWindow.opener = null;
        } else {
          // open agreement
          setOpenModalAgreement(true);
        }
      } else {
        setSnackbarOpen("error", "Waktu psikotest sudah selesai");
      }
    } else {
      setSnackbarOpen("error", "Belum masuk waktu pengerjaan");
    }
  };

  const handleOpenModal = (d, type) => {
    setDataDetail(d);
    setOpenModal(type);
  };

  const handleOpenReimburse = async (d) => {
    setDetailReimburse(d);
    if (d.actions?.action_type === "download-deklarasi") {
      setOpenDeklarasi(true);
      setLoadingDeklarasi(true);
      const cnReimburse = await getCnReimburse({
        candidate_id: d?.candidate_id,
      });
      const resGenerate = await getGenerateTransportasi({
        data: cnReimburse?.data[0],
      });
      console.log(resGenerate?.data);
      setDraftB64(resGenerate?.data);
      setLoadingDeklarasi(false);
    } else {
      setOpenReimburse(true);
    }
  };

  const handleOpenNeop = async (id) => {
    setOpenModal("neop");
    setLoadingModal(true);
    const res = await getMyNeop({ candidate_neop_id: id });
    setCandidateNeop(res.data);
    console.log(res.data);
    setLoadingModal(false);
  };

  const handleAgree = async () => {
    setLoadingAgree(true);
    await updateAgreementTest({ candidate_id: dataDetail?.candidate_id });
    setLoadingAgree(false);
    setOpenModalAgreement(false);
    let copyDataDetail = { ...dataDetail };
    copyDataDetail.is_agree_test = true;
    setTimeout(() => {
      handleStart(copyDataDetail);
    }, 1000);
  };

  const handleConfirmOffering = async (resOffering, docs, reason) => {
    setLoadingOffering(true);
    const paramsUpdate = {};
    paramsUpdate.confirmation_offering = resOffering;
    paramsUpdate.reason = reason;
    paramsUpdate.candidate_id = dataDetail?.candidate_id;
    paramsUpdate.job_posting_id = dataDetail?.job_posting_id;
    paramsUpdate.update_type = "confirm-offering";
    paramsUpdate.offering_doc = docs;
    await updateCandidateSign(paramsUpdate);
    setLoadingOffering(false);
    fetchData();
    setOpenModal(false);
  };

  const handleSaveBerkas = async () => {
    setLoadingBerkas(true);
    const paramsUpdate = { ...dataDetail };
    paramsUpdate.update_type = "candidate-fill-out-forms";
    await updateCandidateSign(paramsUpdate);
    setLoadingBerkas(false);
    fetchData();
    setOpenModal(false);
  };

  const handleView = async (d) => {
    setDataDetail(d);
    setOpenTreatment(true);
    setLoadingForm(true);
    const res = await getSkTreatment({ data: d });
    setFormB64(res.data);
    setLoadingForm(false);
  };

  const handleUpload = async (files, key, old_file) => {
    if (files.length) {
      const validPdfTypes = ["application/pdf"];
      if (!validPdfTypes.includes(files[0].type)) {
        setSnackbarOpen("error", "Hanya file pdf yang diperbolehkan!");
        return;
      }

      setLoadingUpload(true);
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("old_file", old_file);
      const resUpload = await uploadFileGeneral(
        formData,
        "?upload_type=treatment",
      );
      if (typeof resUpload === "string") {
        setLoadingUpload(false);
        setSnackbarOpen("error", resUpload);
        return;
      }
      const resGet = await loadImage(resUpload?.data?.path);
      setDataDetail({
        ...dataDetail,
        [key]: resUpload?.data?.path,
        new_result_treatment_candidate: resGet,
      });

      setLoadingUpload(false);
      setSnackbarOpen("success", "berhasil terupload");
    }
  };

  const handleSendTreatment = async () => {
    console.log(dataDetail);
    await updateCandidateMCU({
      ...dataDetail,
      update_type: "candidate-upload-treatment",
    });
    fetchData();
    setOpenModal(false);
  };

  if (loading) return <CircularProgress />;

  return (
    <>
      <Alert severity="info" sx={{ mb: "1rem" }}>
        Mohon untuk mengecek email secara berkala dan dashboard progress seleksi
        secara berkala.
      </Alert>
      <TableMaterial
        title=""
        selection={false}
        columns={[
          { title: "Job Title", field: "position_group.position_group_name" },
          { title: "Location", field: "job_location_name" },
          {
            title: "Status",
            field: "candidate_logs[0].log_type",
            render: (d) => {
              const cl = d?.candidate_logs;
              if (d.extension && d.extension?.length) {
                const lastHistory =
                  d.extension[0]?.history[d.extension[0].history?.length - 1];
                return (
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {lastHistory?.candidate}
                  </Typography>
                );
              } else {
                const progress = cl && cl[0]?.ref_pipeline?.pipeline_name;
                const strStatus = (() => {
                  const log = cl?.[0];
                  if (!log) return "";

                  if (isEpochOlderThanOneYear(log.candidate_log_id)) {
                    return "Gagal -";
                  }

                  switch (log.log_type) {
                    case "0":
                      return "Gagal";
                    case "1":
                      return "Menunggu";
                    case "2":
                      return "Terjadwal";
                    case "9":
                      return "Lulus";
                    case "3":
                      return "Selesai";
                    case "4":
                      return "Hadir";
                    case "5":
                      return "Tidak Hadir";
                    case "1.5":
                      return "Reschedule, Menunggu";
                    case "2.5":
                      return "Reschedule, Terjadwal";
                    case "100":
                      return "Silahkan ajukan tanggal";
                    case "101":
                      return "Terjadwal";
                    case "110":
                      return "Proses";
                    case "130":
                      return `Proses Treatment`;
                    case "200":
                      return "Konfirmasi Persetujuan Offiering : Silahakan TTD Offering (digital/basah) max. 3 hari setelah diterima.";
                    case "201":
                      return "Bersedia offering";
                    case "202":
                      return "Tidak bersedia offering";
                    case "210":
                      return "Menunggu daftar berkas";
                    case "211":
                      return "Silahkan isi kelengkapan berkas";
                    case "212":
                      return "Berkas sedang divalidasi";
                    case "213":
                      return "Berkas sedang divalidasi";
                    case "220":
                      return "Berkas sedang diproses";
                    case "221":
                      return "Berkas sedang diproses";
                    case "222":
                      return "Berkas sedang diproses";
                    case "230":
                      return "Berkas sedang diproses";
                    case "231":
                      return "Berkas sedang diproses";
                    case "232":
                      return "Berkas sedang diproses";
                    case "240":
                      return "Berkas sedang diproses";
                    case "241":
                      return "Proses Sign Contract";
                    case "242":
                      return "Proses Sign Contract";
                    case "243":
                      return "Selesai Sign Contract";
                    case "244":
                      return "Reimburse";
                    default:
                      return "";
                  }
                })();
                return (
                  <>
                    {cl && cl[0]?.log_type === "2" ? (
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        {progress} {strStatus} <br />
                        {cl[0]?.ref_pipeline?.pipeline_type === "call" ? (
                          <span
                            style={{ fontSize: "12px", fontWeight: "normal" }}
                          >
                            {cl[0]?.started_at_ftd}
                            {/* -{" "}{d?.candidate_logs[0]?.finished_at_ftd} */}
                          </span>
                        ) : (
                          <span
                            style={{ fontSize: "12px", fontWeight: "normal" }}
                          >
                            {d?.psikotest?.started_at_ftd} -{" "}
                            {d?.psikotest?.finished_at_ftd}
                          </span>
                        )}
                      </Typography>
                    ) : (
                      <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        {progress === "Validasi RAS"
                          ? strStatus === "Menunggu"
                            ? "Menunggu Hasil Interview Psikolog"
                            : strStatus + " Interview Psikolog"
                          : strStatus +
                            " " +
                            (cl[0]?.ref_pipeline?.pipeline_type ===
                            "sign-contract"
                              ? ""
                              : progress)}
                        {cl[0]?.log_type === "130" ? (
                          <Stack style={{ fontWeight: "normal" }}>
                            <br />
                            <span>
                              Batas waktu treatment:{" "}
                              {d?.batas_waktu_pemeriksaan_kembali}
                            </span>
                            {/* <br /> */}
                            <span>
                              Batas waktu upload:{" "}
                              {d?.batas_waktu_kirim_hasil_treatment}
                            </span>
                          </Stack>
                        ) : (
                          ""
                        )}
                        {cl[0]?.ref_pipeline?.pipeline_type === "call" ? (
                          <>
                            <br />
                            <span
                              style={{ fontSize: "12px", fontWeight: "normal" }}
                            >
                              {cl[0]?.started_at_ftd}
                            </span>
                          </>
                        ) : cl[0]?.ref_pipeline?.pipeline_type === "mcu" ||
                          cl[0]?.ref_pipeline?.pipeline_type ===
                            "sign-contract" ? null : (
                          <span
                            style={{ fontSize: "12px", fontWeight: "normal" }}
                          >
                            {d?.psikotest?.started_at_ftd} -{" "}
                            {d?.psikotest?.finished_at_ftd}
                          </span>
                        )}
                      </Typography>
                    )}
                  </>
                );
              }
            },
          },
          {
            title: "Action",
            render: (d) => {
              if (d.neop?.candidate_neop_id) {
                return (
                  <Button
                    variant="contained"
                    sx={{ borderRadius: "0.75rem" }}
                    onClick={() => handleOpenNeop(d.neop?.candidate_neop_id)}
                  >
                    NEOP
                  </Button>
                );
              }
              if (d.log_type === "100") {
                return (
                  <Button
                    variant="contained"
                    sx={{ borderRadius: "0.75rem" }}
                    onClick={() => handleOpenModal(d, d.log_type)}
                  >
                    Pilih Tanggal
                  </Button>
                );
              }
              if (d.log_type === "130") {
                return (
                  <Stack direction="row">
                    {/* TODO: dikasih alert untuk batas waktu upload treatment */}
                    {/* <Button
                      variant="contained"
                      sx={{ borderRadius: "0.75rem" }}
                      onClick={() => handleView(d)}
                    >
                      Surat keterangan
                    </Button> */}
                    <Button
                      variant="contained"
                      sx={{ borderRadius: "0.75rem" }}
                      onClick={() => handleOpenModal(d, d.log_type)}
                    >
                      Upload treatment
                    </Button>
                  </Stack>
                );
              }
              if (d.log_type === "200") {
                return (
                  <Button
                    variant="contained"
                    sx={{ borderRadius: "0.75rem" }}
                    onClick={() => {
                      setDataDetail(d);
                      setOpenModal("confirm-offering");
                    }}
                  >
                    Upload Offering
                  </Button>
                );
              }
              if (d.log_type === "211") {
                return (
                  <Button
                    variant="contained"
                    sx={{ borderRadius: "0.75rem" }}
                    onClick={() => {
                      setDataDetail(d);
                      setOpenModal("request-to-complete-data");
                    }}
                  >
                    Upload berkas
                  </Button>
                );
              }
              // if (d.log_type === "244") {
              //   return (
              //     <Button
              //       variant="contained"
              //       onClick={() => handleOpenReimburse(d)}
              //     >
              //       Upload File Reimburse
              //     </Button>
              //   );
              // }
              if (d.extension && d.extension?.length) {
                const lastHistory =
                  d.extension[0]?.history[d.extension[0].history?.length - 1];
                let actionMsg = null;
                if (lastHistory?.actions?.is_action) {
                  if (lastHistory?.actions?.action_type === "mcu-select-date") {
                    actionMsg = "Pilih Tanggal";
                  } else if (
                    lastHistory?.actions?.action_type ===
                    "request-to-complete-data"
                  ) {
                    actionMsg = "Lengkapi Data";
                  }

                  if (
                    lastHistory?.actions?.action_type === "upload-treatment"
                  ) {
                    actionMsg = "Upload Dokumen";
                  }
                }
                return (
                  <Button
                    variant="contained"
                    sx={{ borderRadius: "0.75rem" }}
                    disabled={!actionMsg}
                    onClick={() =>
                      handleOpenModal(d, lastHistory?.actions?.action_type)
                    }
                  >
                    {actionMsg || "Mulai"}
                  </Button>
                );
              } else {
                let isDisableButton =
                  d?.candidate_logs[0]?.ref_pipeline?.pipeline_type === "call"
                    ? !d?.candidate_logs[0]?.meeting_eligible
                    : d?.candidate_logs[0]?.log_type !== "2";
                return (
                  <>
                    <Button
                      variant="contained"
                      sx={{ borderRadius: "0.75rem" }}
                      disabled={isDisableButton}
                      onClick={() => handleStart(d)} //handleStart(d)
                      // onClick={() => handleOpenModal(d, "confirm-test")} //handleStart(d)
                    >
                      Mulai
                    </Button>
                  </>
                );
              }
            },
          },
          // TODO: disable reimburse dulu
          {
            title: "Reimburse",
            hidden: !data[0]?.reimburse[0]?.candidate_reimburse_id,
            render: (d) => {
              if (d.reimburse) {
                return (
                  <>
                    {d.reimburse?.map((r) => (
                      <Button
                        disabled={!r.actions?.is_action}
                        variant="contained"
                        onClick={() => handleOpenReimburse(r)}
                      >
                        {r.actions?.action_type === "upload-file-reimburse" &&
                          "Upload File"}
                        {r.actions?.action_type === "download-deklarasi" &&
                          "Download Deklarasi"}
                        {r.validate_result === "9" && " (Sudah Diverifikasi)"}
                        {r.validate_result === "0" &&
                          " (Tidak Lulus Verifikasi)"}
                        {r.validate_result === "1" && " (Revisi)"}
                      </Button>
                    ))}
                  </>
                );
              }
            },
          },
        ]}
        data={data}
        pageSize={10}
        isLoading={loading}
        font={font}
      />
      <ModalSelectDateMCU
        open={openModal === "100"}
        onClose={() => {
          fetchData();
          setOpenModal("");
        }}
        dataDetail={dataDetail}
      />

      <CustomDialog open={openModal === "130"} maxWidth="md" fullWidth>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <DialogTitle>
            <b>Upload Hasil Treatment</b>
          </DialogTitle>
          <IconButton sx={{ mr: "1rem" }} onClick={() => setOpenModal(false)}>
            <Close />
          </IconButton>
        </Stack>
        <DialogContent dividers>
          <Stack>
            <Button component="label" variant="outlined" sx={{ mb: "1rem" }}>
              Upload <span style={{ fontSize: "10px" }}>{` (pdf)`}</span>
              <VisuallyHiddenInput
                type="file"
                accept="application/pdf"
                onChange={(e) =>
                  handleUpload(
                    e.target.files,
                    "result_treatment_candidate",
                    dataDetail?.result_treatment_candidate,
                  )
                }
              />
            </Button>
            {dataDetail?.result_treatment_candidate && (
              <object
                data={dataDetail[`new_result_treatment_candidate`]}
                type="application/pdf"
                width="100%"
                height="700px"
              >
                <p>
                  Unable to display PDF file.{" "}
                  {/* <a href={baseURL + dataDetail[preview]}>Download</a> instead. */}
                </p>
              </object>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleSendTreatment}>
            Simpan & Kirim
          </Button>
        </DialogActions>
      </CustomDialog>

      {openModal === "request-to-complete-data" && (
        <ModalSignContractRequired
          open={openModal === "request-to-complete-data"}
          onClose={() => {
            fetchData();
            setOpenModal("");
          }}
          dataDetail={dataDetail}
          setDataDetail={setDataDetail}
          handleSave={handleSaveBerkas}
          loadingButton={loadingBerkas}
        />
      )}

      <CustomDialog open={openTreatment} maxWidth="md" fullWidth>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <DialogTitle>
            <b>Surat Keterangan Treatment</b>
          </DialogTitle>
          <IconButton
            sx={{ mr: "1rem" }}
            onClick={() => setOpenTreatment(false)}
          >
            <Close />
          </IconButton>
        </Stack>
        <DialogContent dividers>
          <Stack>
            {loadingForm ? (
              <p>Loading...</p>
            ) : (
              <iframe
                src={`data:application/pdf;base64,${formB64}`}
                style={{ height: "70vh", width: "100%" }}
              />
            )}
          </Stack>
        </DialogContent>
      </CustomDialog>

      <ModalConfirmOffering
        open={openModal === "confirm-offering"}
        onClose={() => {
          fetchData();
          setOpenModal("");
        }}
        dataDetail={dataDetail}
        loading={loadingOffering}
        handleConfirmOffering={handleConfirmOffering}
      />

      {openModal === "upload-treatment" && (
        <ModalUploadTreatment
          open={openModal === "upload-treatment"}
          onClose={() => {
            fetchData();
            setOpenModal("");
          }}
          dataDetail={dataDetail}
        />
      )}

      <ModalUploadReimburse
        open={openReimburse}
        onClose={() => setOpenReimburse(false)}
        dataDetail={detailReimburse}
      />

      <ModalNeop
        open={openModal === "neop"}
        onClose={() => setOpenModal("")}
        loadingModal={loadingModal}
        candidateNeop={candidateNeop}
      />

      <ModalConfirmTest
        open={openModal === "confirm-test"}
        onClose={() => setOpenModal("")}
        loadingModal={loadingModal}
        dataDetail={dataDetail}
        handleStart={handleStart}
      />

      {openModalAgreement && (
        <ModalAgreementTest
          open={openModalAgreement}
          onClose={() => setOpenModalAgreement(false)}
          handleAgree={handleAgree}
          loadingAgree={loadingAgree}
        />
      )}

      <CustomDialog open={openDeklarasi} maxWidth="md" fullWidth>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <DialogTitle>
            <b>Form Deklarasi</b>
          </DialogTitle>
          <IconButton
            sx={{ mr: "1rem" }}
            onClick={() => setOpenDeklarasi(false)}
          >
            <Close />
          </IconButton>
        </Stack>
        <DialogContent dividers>
          <Stack>
            {loadingDeklarasi ? (
              <p>Loading...</p>
            ) : (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${window.location.origin}/${draftB64}`}
                width="100%"
                height="800"
              />
              // <iframe
              //   src={`data:application/pdf;base64,${formB64}`}
              //   style={{ height: "70vh", width: "100%" }}
              // />
            )}
          </Stack>
        </DialogContent>
      </CustomDialog>
    </>
  );
};

export default MyCareer;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
